<template>
  <v-card class="pa-3 contact-list-item">
    <v-row class="spacer" align="center" v-if="!isEditing">
      <v-col sm="4">
        <div class="top-row pb-2">
          {{contact.name.first}} {{contact.name.second}}
        </div>
        <div class="grey--text">
          {{contact.position}}
        </div>
      </v-col>
      <v-col sm="6">
        <div class="top-row pb-2">
          <v-icon small>email</v-icon>
          <a
            v-for="(email, index) in contact.emails"
            :key="index"
            :href="`mailto:${email.value}`"
            class="contact-mail"
          >{{email.value}}</a> <!-- TODO: write more than 1 email from array -->
        </div>
        <div>
          <v-icon small>phone</v-icon> {{contact.phoneNumbers[0].value}} <!-- TODO: write more than 1 phone number from array -->
        </div>
      </v-col>
      <v-col sm="2" class="text-right" v-if="isManaged">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text icon color="kazan" v-on="on" @click="$emit('editContact', contact.id)">
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <span>{{$t('companies.edit_contact_tooltip')}}</span>
        </v-tooltip>
        <wrld-confirm-btn v-model="confirm_modal_opened" @confirm="deleteContact()">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn text icon color="accent" v-on="on" @click="confirm_modal_opened=true">
                <v-icon>delete_forever</v-icon>
              </v-btn>
            </template>
            <span>{{$t('companies.delete_contact_tooltip')}}</span>
          </v-tooltip>
        </wrld-confirm-btn>
      </v-col>
    </v-row>
    <!-- <ContactForm
      v-else
      :contact="this.contact"
      @editDone="isEditing=false"
    /> -->
  </v-card>
</template>

<script>
import ContactForm from '@/components/contacts/ContactForm'

export default {
  name: 'ContactListItem',
  components: {
    ContactForm
  },
  props: {
    isManaged: Boolean,
    contact: Object
  },
  data () {
    return {
      confirm_modal_opened: false,
      isEditing: false
    }
  },
  methods: {
    deleteContact () {
      console.log('contact deleted')
      this.confirm_modal_opened = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .top-row {
    width: 100%;
  }
  .contact-list-item {
    border-top: 1px solid lightgray !important;
    border-radius: 0;

    .contact-mail {
      text-decoration: none;
      padding-left: 5px;

      &:hover {
        color: #006c70;
      }
    }
  }
  .v-btn {
    margin: 0 5px;
  }
</style>
